import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

// Types
export interface ConfigInplay {
  id: string;
  emailAdministracao: string | null;
  criadoEm?: string | null;
  atualizadoEm?: string | null;
}

export interface ConfigInplayInput {
  emailAdministracao: string;
}

// Fragment (to keep fields consistent)
const CONFIG_INPLAY_FIELDS = gql`
  fragment ConfigInplayFields on ConfigInplay {
    id
    emailAdministracao
    criadoEm
    atualizadoEm
  }
`;

// Query
export const CONFIG_INPLAY_QUERY = gql`
  ${CONFIG_INPLAY_FIELDS}
  query ConfigInplay {
    configInplay {
      ...ConfigInplayFields
    }
  }
`;

// Mutation
export const SALVAR_CONFIG_INPLAY = gql`
  ${CONFIG_INPLAY_FIELDS}
  mutation SalvarConfigInplay($input: ConfigInplayInput!) {
    salvarConfigInplay(input: $input) {
      ...ConfigInplayFields
    }
  }
`;

// Service API — nomes espelham ConfigInplayGraphQL.java:26,33 (service.obter()/service.salvar())
export async function obter(): Promise<ConfigInplay | null> {
  const { data } = await apolloClient.query<{ configInplay: ConfigInplay | null }>({
    query: CONFIG_INPLAY_QUERY,
    fetchPolicy: 'no-cache',
  });
  return data?.configInplay ?? null;
}

export async function salvar(input: ConfigInplayInput): Promise<ConfigInplay> {
  const { data } = await apolloClient.mutate<{ salvarConfigInplay: ConfigInplay }, { input: ConfigInplayInput }>({
    mutation: SALVAR_CONFIG_INPLAY,
    variables: { input },
  });
  if (!data?.salvarConfigInplay) throw new Error('Falha ao salvar configuração de e-mail da administração.');
  return data.salvarConfigInplay;
}
